import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import ImageAndVideoUploadForm from '../../../../../../../components/form/ImageAndVideoUploadForm';
import CountOfTotal from '../../../../../../../components/CountOfTotal';
import InputForm from '../../../../../../../components/form/InputForm';
import { REX_ONE_HUNDRED_UNIT } from '../../../../../../../lib/rex';
import { formRequiredRules } from '../../../../../../../lib/formRules';
import { EventSectionAttachment } from '../../../../../../../types/query/event';
import {
  MAXIMUM_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME,
  MAXIMUM_NUMBER_OF_EVENT_ANIMATION_SECTION_TYPE_IMG,
  MINIMUM_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME,
} from '../../../../../../../constants/service/app/eventConstants';
import { REQUIRED_MSG } from '../../../../../../../constants/service/common/formRulesConstants';
import { AnimationSectionStyle } from './style';

interface AnimationSectionProps extends FormComponentProps {
  name: string;
  transitionDelay?: number;
  sectionAttachmentList?: EventSectionAttachment[];
}
const AnimationSection = (props: AnimationSectionProps) => {
  const { form, name, transitionDelay = 500, sectionAttachmentList } = props;
  const transitionDelayFieldValue = form.getFieldValue(`${name}-transitionDelay`) ?? 500;
  const attachments = form.getFieldValue(`${name}-attachments`);

  return (
    <AnimationSectionStyle>
      <InputForm
        form={form}
        type="number"
        label="이미지 전환 시간 (ms 단위)"
        rules={[
          formRequiredRules(true, REQUIRED_MSG, false),
          { pattern: REX_ONE_HUNDRED_UNIT, message: '100 단위로 입력해주세요.' },
        ]}
        initialValue={transitionDelay}
        min={MINIMUM_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME}
        max={MAXIMUM_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME}
        step={100}
        subContent={`${transitionDelayFieldValue || 0}ms =>${transitionDelayFieldValue / 1000}초`}
        name={`${name}-transitionDelay`}
      />
      <ImageAndVideoUploadForm
        vertical={true}
        name={`${name}-attachments`}
        form={form}
        modalTitle="기획전 섹션 이미지"
        label={
          <span>
            기획전 섹션 이미지
            <CountOfTotal content={attachments} maxCnt={MAXIMUM_NUMBER_OF_EVENT_ANIMATION_SECTION_TYPE_IMG} />
          </span>
        }
        rules={[formRequiredRules(true, '필수 정보입니다.', false, 'array')]}
        initialValue={sectionAttachmentList}
        maxCnt={MAXIMUM_NUMBER_OF_EVENT_ANIMATION_SECTION_TYPE_IMG}
        multiple
      />
    </AnimationSectionStyle>
  );
};

export default AnimationSection;
